import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const rebateCsvExtractConstantsStep = defineStepConfig({
  type: "rebate_csv_extract_constants",
  name: "Rebate CSV Extract Constants",
  description:
    "Extract supplier, currency, and date range constants from the raw CSV",
  category: "Transformation",
  libraryModule: "Rebates",

  inputSchema: z.object({
    rebateSessionId: z.string().uuid(),
  }),

  outputSchema: z.object({
    rebateSessionId: z.string().uuid(),
  }),

  configSchema: z.object({}),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "10 minutes",
  },
});
